export default __webpack_public_path__ + "static/bell_w.d8861f41e04e0012686c629653352ff9.svg";